export default function () {
  /* 表格列头 */
  return [
    { label: "序号", type: "index", width: 80 },
    { label: "检测标题", prop: "title" },
    // { label: "档案来源", prop: "source", slots: "source" },
    { label: "用户小程序openid", prop: "openid", },
    { label: "患者手机号", prop: "phone", slots: "phone", width: 160, },
    // { label: "档案", prop: "message", slots: "message", width: 160, },
    { label: "检测图片", prop: "imgUrl", slots: "imgUrl", width: 160, },
    {
      label: "创建日期",
      prop: "createTime",
      width: 180,
    },
    // { label: "会话ID", prop: "answerNumber", slots: "answerNumber", width: 220, },
    {
      label: "操作",
      prop: "operation",
      width: 220,
      slots: "operation",
      fixed: "right",
    },
  ];
}
